
/**
 * Application Entry
 */

 /**
 * import all necessary polyfills
 */
require("babel-polyfill");
require('react-app-polyfill/ie11');
require('react-app-polyfill/stable');
require('core-js/features/array/find');
require('core-js/features/array/includes');
require('core-js/features/number/is-nan');

var ExecutionEnvironment = require('exenv');
var React = require('react');
var ReactDom = require('react-dom');
var TagManager = require('react-gtm-module');
const Cookies = require('js-cookie');

var App = require('./components/App/App.js');
const Utils = require('./utils/Utils');
var AppConstants = require('./constants/AppConstants');
var areIntlLocalesSupported = require('intl-locales-supported').default;
var LayoutConfig = AppConstants.LayoutConfig;

var Application = {
  initializeIntlPolyfill: function(global) {
    var localesMyAppSupports = [
      /* list locales here */
    ];

    if (global.Intl) {
      // Determine if the built-in `Intl` has the locale data we need.
      if (!areIntlLocalesSupported(localesMyAppSupports)) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and replace the constructors with need with the polyfill's.
        var IntlPolyfill = require('intl');
        Intl.NumberFormat   = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
      }
    } else {
      // No `Intl`, so use and load the polyfill.
      global.Intl = require('intl');
    }
  },
  start: function(params) {
    const allowedCookies = Cookies.get('allowedCookieCategories') || 'performance';

    if (allowedCookies.includes('performance')) {
      const tagManagerArgs = {
        gtmId: "GTM-WV3QJWR"
      }
      TagManager.initialize(tagManagerArgs);
    }
  
    // Client-side: mount the app component
    if (ExecutionEnvironment.canUseDOM) {
      this.initializeIntlPolyfill(window);
      var rootElement = document.getElementById(LayoutConfig.ROOT_ELEMENT_ID);
      ReactDom.render(<App/>, rootElement);
    } else {
      // Server-side: return the app's html
      this.initializeIntlPolyfill(global);
      var rootComponentHTML = React.renderToString(App(params));
      return rootComponentHTML;
    }
  }
};

module.exports = Application;